/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";

import ds, { media } from "designsystem";
import { FAQAccordion as FAQAccordionModel } from "models";
import Container from "blocks/Container/Container";
import ScrollDiv from "blocks/ScrollDiv";
import PanelGroup from "kentico-blocks/Accordion/PanelGroup";
import Header3 from "elements/Header3";
import SCROLL from "common/consts/scroll";
import { scrollToElement } from "animations/Animations";
import ImgModal from "blocks/ImgModal/ImgModal";

const Accordion = styled.div`
  padding: ${ds.get("metrics.s")};
  padding-top: 0;
  width: 100%;

  ${media.desktop`
    padding: 0 ${ds.get("metrics.l")} ${ds.get("metrics.m")};
  `};
  
  .panel-collapse a {
    font-weight: 400;
    color: ${ds.get("colors.brand.product")};
    text-decoration: none;
  }
`;

@inject("windowStore")
@observer
export default class FAQAccordion extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(FAQAccordionModel).isRequired,
  };

  activeKey = observable.box(null);

  constructor(props) {
    super(props);
    const {
      data: {
        accordionItems,
      },
    } = this.props;
    this.scrollDivRefs = accordionItems.map(() => React.createRef());
    this.state = {
      showImgModal: false
    }
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  scrollToHeader(elementRefIndex) {
    if (elementRefIndex > 0) {
      const scrollDivRef = this.scrollDivRefs[elementRefIndex - 1].current;
      scrollToElement(scrollDivRef, 300);
    } else {
      scrollToElement(this.scrollDivRefs[0].current, 0);
    }
  }

  handleOpenModal () {
    this.setState({ showImgModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showImgModal: false });
  }
  
  render() {
    const {
      data: {
        title,
        accordionItems,
        id,
      },
      windowStore: {
        isOnTablet,
      },
    } = this.props;
    const isAccordionSpread = (!!this.activeKey.get() || this.activeKey.get() === 0);
    const scrollDivOffset = (isOnTablet ? `-${SCROLL.MOBILE_TOP_OFFSET}px` : `-${SCROLL.DESKTOP_TOP_OFFSET}px`);

    return (
      <Container>
        <Accordion>
          <Header3>
            {title}
          </Header3>
          <PanelGroup
            accordion
            defaultActiveKey={0}
            activeKey={this.activeKey.get()}
            onSelect={activeKey => this.activeKey.set(activeKey)}
            id={`FAQ.PanelGroup-${id}`}
          >
            {accordionItems.map((accordionItem, index) => {
              const {
                text,
                title,
                id,
                videoLink,
                image,
              } = accordionItem;
              const isActive = this.activeKey.get() === index;
              return (
                <PanelGroup.Panel
                  eventKey={index}
                  key={id}
                >
                  <PanelGroup.Heading data-isactive={isActive}>
                    <PanelGroup.Title
                      toggle
                      onClick={() => this.scrollToHeader(index)}
                    >
                      <ScrollDiv
                        offset={scrollDivOffset}
                        innerRef={this.scrollDivRefs[index]}
                      />
                      <PanelGroup.TitleText isActive={isActive}>
                        <span>{title}</span>
                        <PanelGroup.Arrow
                          isActive={isActive}
                        />
                      </PanelGroup.TitleText>
                    </PanelGroup.Title>
                  </PanelGroup.Heading>
                  <PanelGroup.Body
                    data-isspread={isAccordionSpread}
                    collapsible
                  >
                    <PanelGroup.Body.Paragraph
                      dangerouslySetInnerHTML={{
                        __html: text,
                      }}
                      />
                    {videoLink
                      && (
                        <PanelGroup.Body.Video style={{width: '100%'}}>
                          <iframe
                            src={videoLink}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </PanelGroup.Body.Video>
                      )}
                    {image
                      && (
                        <React.Fragment>
                          <PanelGroup.Body.Image
                            src={image}
                            alt={title}
                            onClick={this.handleOpenModal}
                            style={{cursor: 'pointer'}}
                          />
                          {this.state.showImgModal && 
                            <ImgModal closeModal = {this.handleCloseModal} image={image} alt={title}/>
                          }
                        </React.Fragment>
                      )}
                  </PanelGroup.Body>
                </PanelGroup.Panel>
              );
            })}
          </PanelGroup>
        </Accordion>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/FAQAccordion/index.jsx